import { Container } from '@plone/components';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const PostFooter = () => {
  return (
    <Container className="default">
      <ul>
        <li>
          <UniversalLink href="/medien-service/impressum">
            Impressum
          </UniversalLink>
        </li>
        <li>
          <UniversalLink href="/medien-service/datenschutz">
            Datenschutz
          </UniversalLink>
        </li>
        <li>
          <UniversalLink href="/sitemap">Sitemap</UniversalLink>
        </li>
        <li>
          <UniversalLink href="/medien-service/barrierefreiheit">
            Erklärung zur Barrierefreiheit
          </UniversalLink>
        </li>
        <li>
          <UniversalLink href="/medien-service/urheberrechte">
            Bildrechte
          </UniversalLink>
        </li>
        <li>
          <UniversalLink href="/medien-service/kontakt">Kontakt</UniversalLink>
        </li>
      </ul>
    </Container>
  );
};

export default PostFooter;
